// extracted by mini-css-extract-plugin
module.exports = {"title":"GroupHeadline_title__6ABmB","description":"GroupHeadline_description__3q08G","price":"GroupHeadline_price__2zOzh","code":"GroupHeadline_code__3DSNc"};